import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type UpdateRestaurantCommunicationResult =
	| { success: true; errors: null }
	| { success: false; errors: MutationHandlerError }

const updateRestaurantCommunication = async ({
	id,
	note,
}: {
	id: string
	note: string
}): Promise<UpdateRestaurantCommunicationResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation UpdateRestaurantCommunication($id: ID!, $note: String!) {
					updateRestaurantCommunication(id: $id, note: $note) {
						success
						error
					}
				}
			`,
			variables: { id, note },
			errorPolicy: 'all',
			refetchQueries: ['RestaurantCommunications', 'RestaurantAlarms'],
		})

		if (errors) return { success: false, errors }
		const result = data?.updateRestaurantCommunication
		if (!result?.success) {
			return { success: false, errors: result?.error || 'Speichern fehlgeschlagen' }
		}
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default updateRestaurantCommunication
